import { getEventModelName } from "@/entities/data-model";
import type { EventIdentity } from "@/entities/data-model";

function toPascalCase(str: string) {
    return str
        .replace(/[_\- ]+/g, " ")
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join("");
}

const getDataModelLikeKey = ({ eventType, relation }: EventIdentity) => toPascalCase(`${relation} ${eventType ?? ""}`);

const PREDEFINED_EVENT_TYPES: ReadonlyArray<string | null> = [
    "Birth",
    "Death",
    "Burial",
    "Census",
    "Marriage",
    "Divorce",
    "Military",
    "Residence",
    "Other",
    null,
];

/** Predefined Self events take the pre-declared `FormValues["events"]` spelling (e.g. `SelfBirth`); everything else derives its key like the rest of the client does. */
export const resolveEventKey = (identity: EventIdentity): string | null =>
    PREDEFINED_EVENT_TYPES.includes(identity.eventType) && identity.relation === "Self"
        ? getDataModelLikeKey(identity)
        : getEventModelName(identity);
